import { FC, PropsWithChildren } from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #1e64ddff;
`;

const Container = styled.div`
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: #9095a1ff;
`;

const TosLink: FC<PropsWithChildren<{ to: string }>> = ({ to, children }) => {
  return (
    <StyledLink to={to} target="_blank">
      {children}
    </StyledLink>
  );
};

const TermsOfService: FC = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Trans
        i18nKey="termsOfService.label"
        values={{
          termsLink: t("termsOfService.termsLink"),
          privacyPolicyLink: t("termsOfService.privacyPolicyLink"),
          appName: process.env.REACT_APP_APP_NAME,
        }}
        components={{
          anchorTerms: <TosLink to={t("termsOfService.termsUrl")} />,
          anchorPrivacy: <TosLink to={t("termsOfService.privacyPolicyUrl")} />,
        }}
      />
    </Container>
  );
};

export default TermsOfService;
